export const shouldAddItem = (items, filterText) => {
    return items?.filter((item) => item?.toLowerCase().includes(filterText.toLowerCase())).length > 5;
  };